export default __webpack_public_path__ + "static/techguru-example12-ef7155df1ab34c052a763a61a728124c.png";